import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './AllProjects.css';

const AllProjects = () => {
  const projects = [
    {
      title: "ApexAI - Racing Simulator",
      description: "Developed a virtual racing simulator using NEAT for AI-driven racing-line optimization across varied tracks. Built an interactive Streamlit frontend for real-time AI monitoring and dynamic data visualization.",
      tags: ["Python", "Streamlit", "NEAT", "MongoDB"],
      icon: "fas fa-car",
      gradient: "gradient-1",
      github: "https://github.com/RahulV2478/FormulaHacks.git",
      live: "https://devpost.com/software/apexai"
    },
    {
      title: "RL Fine-Tuning for Summarization Models",
      description: "Research paper on warm-starting, stability mechanisms, and reward design for RL fine-tuning of small summarization models. Demonstrated that SCST from SFT achieves ROUGE-L of 0.205, maintaining SFT performance, while SCST from base achieves only 0.142.",
      tags: ["PyTorch", "Reinforcement Learning", "NLP", "Research"],
      icon: "fas fa-brain",
      gradient: "gradient-2",
      github: "https://github.com/rohitchawla28/rl-finetune.git",
      live: "/NLPFinalPaper.pdf"
    },
    {
      title: "Diffusion Models (DDPM/DDIM)",
      description: "Implemented Denoising Diffusion Probabilistic Models (DDPM) and Denoising Diffusion Implicit Models (DDIM) for image generation. Built training pipelines for CIFAR dataset with noise scheduling, forward/reverse diffusion processes, and sampling algorithms.",
      tags: ["PyTorch", "Deep Learning", "Computer Vision", "Generative Models"],
      icon: "fas fa-image",
      gradient: "gradient-1",
      github: "https://github.com/RahulV2478/gen-vis-assignment-4.git",
      live: "#"
    },
    {
      title: "Image Regression CNN - Couch Detection",
      description: "Built a PyTorch CNN model for image regression that predicts bounding box locations of couches in unfurnished rooms. Implemented data loading, training pipeline, and evaluation with visualization of predicted bounding boxes on test images.",
      tags: ["PyTorch", "CNN", "Computer Vision", "Image Regression"],
      icon: "fas fa-couch",
      gradient: "gradient-2",
      github: "https://github.com/RahulV2478/image_regression.git",
      live: "#"
    },
    {
      title: "Motion Autoencoder",
      description: "Trained a convolutional autoencoder to learn temporal joint-based motion representations from CMU Mocap datasets. Enabled motion interpolation, retargeting, and trajectory reconstruction from latent embeddings.",
      tags: ["PyTorch", "Deep Learning", "BVH", "Computer Vision"],
      icon: "fas fa-running",
      gradient: "gradient-3",
      github: "https://github.com/RahulV2478/gen_vis_assignment_3",
      live: "#"
    },
    {
      title: "IMC Trading Competition",
      description: "Ranked 59th worldwide and 20th in the U.S. out of 3,500+ teams. Implemented market-making and arbitrage algorithms with risk limits and latency constraints.",
      tags: ["Python", "Pandas", "NumPy", "Algorithmic Trading"],
      icon: "fas fa-chart-line",
      gradient: "gradient-3",
      github: "https://github.com/sraghauv/imc-prosperity",
      live: "#"
    }
  ];

  return (
    <div className="all-projects-page">
      <Navbar />
      <div className="all-projects-header">
        <Link to="/" className="back-button">
          <i className="fas fa-arrow-left"></i> Back to Home
        </Link>
        <h1 className="all-projects-title">All Projects</h1>
        <p className="all-projects-subtitle">Explore my complete portfolio of projects</p>
      </div>
      <div className="container">
        <div className="all-projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card-large">
              <div className={`project-image-large ${project.gradient}`}>
                <div className="project-placeholder-large">
                  <i className={project.icon}></i>
                </div>
              </div>
              <div className="project-content-large">
                <h3 className="project-title-large">{project.title}</h3>
                <p className="project-description-large">{project.description}</p>
                <div className="project-tags-large">
                  {project.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="tag-large">{tag}</span>
                  ))}
                </div>
                <div className="project-links-large">
                  <a href={project.github} className="project-link-large">
                    <i className="fab fa-github"></i> Code
                  </a>
                  {project.live && project.live !== "#" && (
                    <a href={project.live} className="project-link-large">
                      <i className="fas fa-external-link-alt"></i> Live
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AllProjects;

